
import { Component, Vue } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon.vue';
import ImportBlockForm from '@/components/Forms/Blocks/ImportBlockForm.vue';
import { InviteManager } from '@/store/models/jwt';
import { ValidationObserver } from 'vee-validate';
import { CommonStore, FarmStore, UserStore } from '@/store/modules';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { UserTypes } from '@/store/models/user';
// import { isSuperuser, roleChecker } from '@/utils/jwt';

@Component({
  components: {
    SvgIcon,
    ImportBlockForm,
    ValidationObserver,
    QvInput,
    QvSelect
  }
})
export default class InviteManagerPage extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };

  inviteManager: InviteManager[] = [{ email: '' }] as InviteManager[];
  farmOptions: { value: number; label: string }[] = [];

  get isAdmin() {
    return false;
    // return roleChecker(['admin']) || isSuperuser();
  }

  get farms() {
    return FarmStore.Farms.map(x => {
      return { value: x.id, label: x.name };
    });
  }

  get owners() {
    return UserStore.SimpleUserList.filter(x => x.role == UserTypes.OWNER).map(
      x => {
        return { value: x.id, label: x.fullName };
      }
    );
  }

  get selectedFarmBlock() {
    return CommonStore.SelectedFarmBlock;
  }

  //eslint-disable-next-line
  filterOption(val: any, update: any, abort: any) {
    update(() => {
      const needle = val.toLowerCase();
      this.farmOptions = this.farms.filter(
        v => v.label.toLowerCase().indexOf(needle) > -1
      );
    });
  }

  addInvitation() {
    this.inviteManager.push({ email: '', farm: this.selectedFarmBlock.farmId });
  }
  removeInvitation(index: number) {
    this.inviteManager.splice(index, 1);
  }

  async onSubmit() {
    for (const invitation of this.inviteManager) {
      invitation.email = invitation.email.toLowerCase();
    }
    const response = await UserStore.inviteManager(this.inviteManager);
    this.$q.notify({
      type: 'positive',
      message: response.message
    });
    this.$router.push({ name: 'Settings' });
  }
  onReset() {
    this.inviteManager = [
      { email: '', farm: this.selectedFarmBlock.farmId }
    ] as InviteManager[];
    requestAnimationFrame(() => {
      this.$refs.observer.reset();
    });
  }
  async created() {
    await FarmStore.getAllMyFarms();
    this.farmOptions = this.farms;
    this.inviteManager = [
      { email: '', farm: this.selectedFarmBlock.farmId }
    ] as InviteManager[];
  }
}
